import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps a product block in sync with the selected variant.
 * When a variant is selected, Horizon fetches the section HTML for it; this element
 * takes its own counterpart (same `data-live-key`) from that HTML and morphs into it.
 * Same approach as product-inventory.js, but reusable by any block.
 */
class ProductLiveBlock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const key = this.dataset.liveKey;
    if (!key) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const next = html.querySelector(`product-live-block[data-live-key="${CSS.escape(key)}"]`);
        if (!next) return;

        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-live-block] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-live-block')) {
  customElements.define('product-live-block', ProductLiveBlock);
}
